<template>
  <div class="container quiz-wrapper">
    <div class="quiz-slide-title">
      {{ presentation.name }}
    </div>
    <div v-if="isShowQuizList" class="quiz-slide-content">
      <div v-for="(quizAnswer, index) in myQuizAnswers" :key="quizAnswer.id">
        <QuizItemReview
          :quizAnswer="quizAnswer"
          :order="index + 1"
          :totalQuiz="totalQuiz"
        />
      </div>
    </div>
    <EmptyQuizAnswer v-else />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AnswersAPI from '@/api/answers'
import QuizStatuses from '@/constants/QuizStatuses'
import QuizItemReview from './QuizItemReview.vue'
import EmptyQuizAnswer from './EmptyQuizAnswer.vue'

const ALTER_BODY_CLASS = 'quiz-answers'

export default {
  components: {
    QuizItemReview,
    EmptyQuizAnswer,
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
      slides: (state) => state.slides,
      presentation: (state) => state.presentation,
      audienceId: (state) => state.audienceId,
      activeTabView: (state) => state.activeTabView,
      myQuizAnswers: (state) => state.myQuizAnswers,
      isMyQuizAnswersLoaded: (state) => state.isMyQuizAnswersLoaded,
    }),
    totalQuiz() {
      return this.myQuizAnswers.length
    },
    isPassedLastQuiz() {
      const currentSlideId = this.slide && this.slide.id
      const currentSlideStatus = this.slide && this.slide.quizStatus
      const slideList = this.slides || []

      const currentSlideIndex = slideList.findIndex((item) => item.id === currentSlideId)
      const reverseListQuizIndex = [...slideList].reverse().findIndex((item) => item.type === 'pickAnswer')
      const lastQuizSlideIndex = slideList.length - reverseListQuizIndex - 1

      if (currentSlideIndex === lastQuizSlideIndex) {
        return currentSlideStatus === QuizStatuses.RESULT_SCREEN
      }

      return currentSlideIndex >= lastQuizSlideIndex
    },
    isShowQuizList() {
      return this.isPassedLastQuiz && !!this.totalQuiz
    },
  },
  watch: {
    isPassedLastQuiz: {
      handler(value) {
        if (value && !this.totalQuiz) {
          this.getMyQuizAnswers()
          this.setIsMyQuizAnswersLoadedAction(true)
        }
      },
      immediate: true,
    },
    '$store.state.activeTabView': {
      handler(value) {
        if (value === 'answers') {
          document.body.classList.add(ALTER_BODY_CLASS)
          window.scrollTo(0, 0)
        } else {
          document.body.classList.remove(ALTER_BODY_CLASS)
        }
      },
    },
  },
  methods: {
    ...mapActions(['setIsMyQuizAnswersLoadedAction', 'setMyQuizAnswersAction']),
    async getMyQuizAnswers() {
      const myQuizAnswers = await AnswersAPI.getMyQuizAnswers({
        presentationId: this.presentation && this.presentation.id,
        audienceId: this.audienceId,
      })

      this.setMyQuizAnswersAction(myQuizAnswers)
    },
  },
}
</script>

<style lang="scss">
body.quiz-answers {
  background: linear-gradient(180deg, #FFF 0%, #EFF1F7 34.38%);

  #slide-image-bg {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.quiz-wrapper {
  max-width: 768px;
  margin: 0 auto;
  padding: 26px 1rem;
}

.quiz-slide-title {
  font-size: 24px;
  font-weight: 700;
  color: #282E3E;
  text-align: center;
  margin-bottom: 16px;
}
</style>
